import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { FiPlay } from "react-icons/fi";

const THUMBNAIL_IMAGE = "./images/consultation/community.jpg";
// Extract the YouTube Embed URL here
const YOUTUBE_EMBED_URL = "https://www.youtube.com/embed/3L7NRUUHCoQ?autoplay=1&mute=1"; 

function AffiliateVideo() {
    const [toggler, setToggler] = useState(false);

    // 1. Define the custom iframe element
    const customIframe = (
        <div 
          style={{
            position: 'relative',
            width: '90vw', 
            // Calculate height for 16:9 aspect ratio based on 90vw width
            paddingTop: '50.625vw', 
            margin: '0 auto',
            display: 'block', 
            marginTop: '30px',
          }}
        >
            <iframe
                // 👇 ADDED REFERRERPOLICY HERE
                referrerPolicy="strict-origin-when-cross-origin" 
                src={YOUTUBE_EMBED_URL}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                }}
            />
        </div>
    );


    return (
        <div className="row row--15 m-0">
            <div className="col-12 p-0">
                <div className="video-popup icon-center w-100">
                    <div className="thumbnail w-100">
                        {/* Use the extracted thumbnail path */}
                        <img className="radius-small w-100" src={THUMBNAIL_IMAGE} alt="Video Thumbnail" />
                    </div>
                    <div className="video-icon">
                        <button className="btn-default rounded-player" onClick={() => setToggler(!toggler)}>
                            <span><FiPlay /></span>
                        </button>
                    </div>
                    <FsLightbox
                        toggler={toggler}
                        // 2. Pass the custom iframe element as the source
                        sources={[customIframe]} 
                    />
                </div>
            </div>
        </div>
    );
}

export default AffiliateVideo;